/**
 * Dữ liệu mẫu của module `van-ban` cho `?mock=` và chạy `pnpm dev` không có backend.
 *
 * 29 mẫu NĐ30 sinh tự động từ hai migration của bản native (cùng id, tên, ký hiệu, mô tả với
 * `modules/van-ban/migrations/V1.0.0__khoi_tao.sql`). Đơn vị và tích hợp theo seed của foxainative.
 * Không quyết màu ở đây (CLAUDE.md): bảng tông nằm ở `modules/xu-ly-van-ban/constants.ts`.
 */
import type { DonVi, MauVanBan, NhatKyWebhook, TichHop } from '../modules/xu-ly-van-ban/types';

const LUC = '2026-07-06T09:00:00Z';

const BO_CUC_ND30 = [
  'Quốc hiệu và Tiêu ngữ',
  'Tên cơ quan, tổ chức ban hành văn bản',
  'Số, ký hiệu của văn bản',
  'Địa danh và thời gian ban hành',
  'Tên loại và trích yếu nội dung văn bản',
  'Nội dung văn bản',
  'Chức vụ, họ tên và chữ ký của người có thẩm quyền',
  'Dấu, chữ ký số của cơ quan, tổ chức',
  'Nơi nhận',
];

function mauNd30(id: string, name: string, symbol_code: string, description: string): MauVanBan {
  return {
    id,
    name,
    symbol_code,
    source: 'NGHI_DINH_30',
    source_label: 'Nghị định 30/2020/NĐ-CP',
    status: 'DANG_DUNG',
    status_label: 'Đang dùng',
    description,
    structure: BO_CUC_ND30,
    fields: null,
    body_template: null,
    default_meta: null,
    compose_mode: 'AI_GENERATE',
    template_content: null,
    original_filename: null,
    preview_content: null,
    created_at: LUC,
    updated_at: LUC,
  };
}

export const MOCK_MAU_VAN_BAN: MauVanBan[] = [
  mauNd30("11111111-0001-0000-0000-000000000000", "Công văn", "CV", "Văn bản hành chính dùng để trao đổi, đôn đốc, trả lời hoặc đề nghị giữa các cơ quan, tổ chức. Không có tên loại; trích yếu \"V/v\" đặt dưới số và ký hiệu."),
  mauNd30("11111111-0002-0000-0000-000000000000", "Quyết định (cá biệt)", "QĐ", "Văn bản quyết định về một vấn đề cụ thể: ban hành quy chế, tổ chức, nhân sự, khen thưởng... Có phần căn cứ ban hành và bố cục theo Điều."),
  mauNd30("11111111-0003-0000-0000-000000000000", "Tờ trình", "TTr", "Văn bản trình cấp trên xem xét, phê duyệt một chủ trương, đề án, dự thảo văn bản hoặc phương án công tác."),
  mauNd30("11111111-0004-0000-0000-000000000000", "Báo cáo", "BC", "Văn bản phản ánh tình hình, kết quả thực hiện nhiệm vụ; gồm đánh giá kết quả, tồn tại hạn chế và hướng ..."),
  mauNd30("11111111-0005-0000-0000-000000000000", "Thông báo", "TB", "Văn bản thông tin về một nội dung, sự việc, kết luận cuộc họp... đến các cơ quan, tổ chức, cá nhân liên quan."),
  mauNd30("11111111-0006-0000-0000-000000000000", "Kế hoạch", "KH", "Văn bản xác định mục đích yêu cầu, nội dung nhiệm vụ, giải pháp, tiến độ và tổ chức thực hiện một công việc cụ..."),
  mauNd30("11111111-0007-0000-0000-000000000000", "Biên bản", "BB", "Văn bản ghi lại diễn biến, kết quả cuộc họp, sự việc; có chữ ký của người chủ trì và thư ký."),
  mauNd30("11111111-0008-0000-0000-000000000000", "Giấy mời", "GM", "Văn bản mời cơ quan, tổ chức, cá nhân tham dự cuộc họp, hội nghị, sự kiện với thời gian, địa điểm cụ thể."),
  mauNd30("11111111-0009-0000-0000-000000000000", "Chỉ thị", "CT", "Văn bản chỉ đạo, đôn đốc các cơ quan, đơn vị cấp dưới tập trung thực hiện nhiệm vụ trong tâm, cấp bách."),
  mauNd30("11111111-0010-0000-0000-000000000000", "Nghị quyết (cá biệt)", "NQ", "Văn bản ghi nhận nghị quyết của tập thể lãnh đạo về chủ trương, chính sách, nhiệm vụ cụ thể."),
  mauNd30("11111111-0011-0000-0000-000000000000", "Quy chế", "QC", "Văn bản quy định chế độ, nguyên tắc, quyền hạn, trách nhiệm và quan hệ công tác của cơ quan, tổ chức; thường ban hành kèm theo Quyết định."),
  mauNd30("11111111-0012-0000-0000-000000000000", "Quy định", "QyĐ", "Văn bản xác định nguyên tắc, tiêu chuẩn, biện pháp áp dụng cho một lĩnh vực công tác; thường ban hành kèm theo Quyết định."),
  mauNd30("11111111-0013-0000-0000-000000000000", "Thông cáo", "TC", "Văn bản công bố công khai của cơ quan nhà nước về một sự kiện, sự việc quan trọng."),
  mauNd30("11111111-0014-0000-0000-000000000000", "Hướng dẫn", "HD", "Văn bản hướng dẫn triển khai thực hiện nội dung của văn bản cấp trên hoặc quy định của pháp luật."),
  mauNd30("11111111-0015-0000-0000-000000000000", "Chương trình", "CTr", "Văn bản xác định mục tiêu, nội dung và trình tự thời gian tiến hành một hoạt động, công tác."),
  mauNd30("11111111-0016-0000-0000-000000000000", "Phương án", "PA", "Văn bản trình bày cách thức, giải pháp tổ chức thực hiện một công việc, nhiệm vụ cụ thể."),
  mauNd30("11111111-0017-0000-0000-000000000000", "Đề án", "ĐA", "Văn bản trình bày có hệ thống về mục tiêu, nội dung, giải pháp và nguồn lực để thực hiện một nhiệm vụ lớn."),
  mauNd30("11111111-0018-0000-0000-000000000000", "Dự án", "DA", "Văn bản trình bày kế hoạch tổng thể triển khai một công trình, hoạt động đầu tư trong thời gian xác định."),
  mauNd30("11111111-0019-0000-0000-000000000000", "Hợp đồng", "HĐ", "Văn bản thỏa thuận giữa các bên về quyền và nghĩa vụ trong thực hiện công việc, giao dịch."),
  mauNd30("11111111-0020-0000-0000-000000000000", "Công điện", "CĐ", "Văn bản truyền đạt nhanh mệnh lệnh, chỉ đạo hoặc thông tin khẩn của cơ quan có thẩm quyền."),
  mauNd30("11111111-0021-0000-0000-000000000000", "Bản ghi nhớ", "BGN", "Văn bản ghi nhận nội dung đã trao đổi, thống nhất sơ bộ giữa các bên làm cơ sở tiếp tục hợp tác."),
  mauNd30("11111111-0022-0000-0000-000000000000", "Bản thỏa thuận", "BTT", "Văn bản ghi nhận sự thống nhất giữa các bên về nội dung, phạm vi hợp tác, phối hợp."),
  mauNd30("11111111-0023-0000-0000-000000000000", "Giấy ủy quyền", "GUQ", "Văn bản giao cho cá nhân, tổ chức thay mặt thực hiện công việc trong phạm vi được ủy quyền."),
  mauNd30("11111111-0024-0000-0000-000000000000", "Giấy giới thiệu", "GGT", "Văn bản giới thiệu cán bộ, công chức đến cơ quan, tổ chức khác liên hệ công tác."),
  mauNd30("11111111-0025-0000-0000-000000000000", "Giấy nghỉ phép", "GNP", "Văn bản xác nhận việc cho phép cán bộ, công chức, viên chức nghỉ phép theo chế độ."),
  mauNd30("11111111-0026-0000-0000-000000000000", "Phiếu gửi", "PG", "Văn bản kèm theo tài liệu gửi đi để cơ quan nhận theo dõi, xác nhận đã nhận."),
  mauNd30("11111111-0027-0000-0000-000000000000", "Phiếu chuyển", "PC", "Văn bản dùng để chuyển hồ sơ, tài liệu, đơn thư đến cơ quan, đơn vị có thẩm quyền xử lý."),
  mauNd30("11111111-0028-0000-0000-000000000000", "Phiếu báo", "PB", "Văn bản báo tin về việc chuyển, trả hoặc tiếp nhận hồ sơ, tài liệu."),
  mauNd30("11111111-0029-0000-0000-000000000000", "Thư công", "TCg", "Thư của lãnh đạo cơ quan gửi cơ quan, tổ chức, cá nhân nhân dịp lễ, sự kiện. Không ghi tên loại văn bản; ký hiệu chỉ quy ước (không thuộc bảng chữ viết tắt NĐ30)."),
  {
    id: '22222222-0001-0000-0000-000000000000',
    name: 'Đơn xin nghỉ phép',
    symbol_code: 'ĐXNP',
    source: 'TUY_CHINH',
    source_label: 'Tùy chỉnh',
    status: 'DANG_DUNG',
    status_label: 'Đang dùng',
    description: 'Mẫu đơn cán bộ xin nghỉ phép năm, có trường điền tay và trường AI tự điền.',
    structure: null,
    fields: [
      { key: 'kinh_gui', label: 'Kính gửi', type: 'TEXT', required: true, ai_fill: true },
      { key: 'ho_ten', label: 'Họ và tên', type: 'TEXT', required: true, ai_fill: false },
      { key: 'loai_nghi', label: 'Loại nghỉ', type: 'SELECT', options: ['Phép năm', 'Nghỉ ốm'], ai_fill: false },
      { key: 'ly_do', label: 'Lý do', type: 'TEXTAREA', hint: 'Lý do xin nghỉ', ai_fill: true },
    ],
    body_template:
      '<p style="margin:6px 0;text-align:justify;">Kính gửi: {{kinh_gui}}</p>' +
      '<p style="margin:6px 0;text-align:justify;">Tôi tên là {{ho_ten}}, xin được nghỉ {{loai_nghi}} vì {{ly_do}}.</p>',
    default_meta: { dd: 'Hà Nội', cv: 'NGƯỜI LÀM ĐƠN', header_style: 'CENTERED' },
    compose_mode: 'FIELD_FILL',
    template_content: null,
    original_filename: null,
    preview_content: null,
    created_at: LUC,
    updated_at: LUC,
  },
];

function donVi(
  id: string,
  name: string,
  type: DonVi['type'],
  functions: string,
  supervisor: string | null,
  parent_id: string | null,
  score: number,
): DonVi {
  return { id, name, type, functions, supervisor, parent_id, parent_name: null, score, created_at: LUC, updated_at: LUC };
}

const U = (n: number) => `33333333-000${n}-0000-0000-000000000000`;

export const MOCK_DON_VI: DonVi[] = [
  donVi(U(1), 'UBND tỉnh ABC', 'CO_QUAN', 'Quản lý nhà nước toàn diện trên địa bàn tỉnh; chỉ đạo, điều hành hoạt động của các sở, ban, ngành và UBND cấp huyện.', 'Nguyễn Thành Công', null, 9.2),
  donVi(U(2), 'Sở Thông tin và Truyền thông', 'CO_QUAN', 'Tham mưu UBND tỉnh quản lý nhà nước về báo chí, xuất bản, bưu chính, viễn thông, công nghệ thông tin và chuyển đổi số.', 'Nguyễn Văn An', U(1), 9.0),
  donVi(U(3), 'Văn phòng Sở', 'PHONG_BAN', 'Tổng hợp, hành chính, văn thư - lưu trữ; quản trị công sở; đầu mối tiếp nhận và phát hành văn bản của Sở.', 'Trần Thị Mai', U(2), 8.7),
  donVi(U(4), 'Phòng Công nghệ thông tin', 'PHONG_BAN', 'Quản lý hạ tầng CNTT, triển khai chuyển đổi số, vận hành các hệ thống thông tin dùng chung của tỉnh.', 'Phạm Quốc Huy', U(2), 9.4),
  donVi(U(5), 'Phòng Thông tin - Báo chí - Xuất bản', 'PHONG_BAN', 'Quản lý hoạt động báo chí, xuất bản, thông tin đối ngoại và thông tin cơ sở trên địa bàn.', 'Lê Hoàng Nam', U(2), 8.3),
  donVi(U(6), 'Nguyễn Văn An', 'CA_NHAN', 'Giám đốc Sở: chỉ đạo, điều hành toàn diện hoạt động của Sở; trực tiếp phụ trách công tác tổ chức, tài chính và chuyển đổi số.', null, U(2), 9.5),
  donVi(U(7), 'Trần Thị Mai', 'CA_NHAN', 'Chánh Văn phòng: phụ trách công tác hành chính - tổng hợp, văn thư lưu trữ, bộ phận một cửa.', null, U(3), 8.9),
  donVi(U(8), 'Phạm Quốc Huy', 'CA_NHAN', 'Trưởng phòng CNTT: phụ trách hệ thống thông tin, an toàn thông tin và dữ liệu số.', null, U(4), 9.1),
];

export const MOCK_TICH_HOP: TichHop[] = [
  {
    id: '44444444-0001-0000-0000-000000000000',
    name: 'Hệ thống QLVB&ĐH tỉnh ABC',
    source_label: 'QLVB',
    api_key_prefix: 'fxai_Zk3QaP9w',
    default_doc_type: 'Công văn',
    auto_summarize: true,
    inbound_auth_type: 'API_KEY',
    inbound_format: 'MULTIPART',
    webhook_url: 'https://qlvb.abc.gov.vn/api/foxai/ket-qua',
    webhook_method: 'POST',
    webhook_auth_type: 'BEARER',
    webhook_triggers: ['AFTER_SUMMARIZE', 'ON_ERROR'],
    webhook_retry_max: 3,
    is_active: true,
    created_at: LUC,
    updated_at: LUC,
  },
  {
    id: '44444444-0002-0000-0000-000000000000',
    name: 'Cổng dịch vụ công tỉnh',
    source_label: 'CONG_DVC',
    api_key_prefix: 'fxai_m2XcR7tL',
    default_doc_type: 'Khác',
    auto_summarize: false,
    inbound_auth_type: 'BEARER',
    inbound_format: 'JSON',
    webhook_url: null,
    webhook_method: 'POST',
    webhook_auth_type: 'NONE',
    webhook_triggers: [],
    webhook_retry_max: 3,
    is_active: false,
    created_at: '2026-07-02T09:00:00Z',
    updated_at: '2026-07-02T09:00:00Z',
  },
];

export const MOCK_NHAT_KY_WEBHOOK: NhatKyWebhook[] = [
  {
    id: '55555555-0001-0000-0000-000000000000',
    integration_config_id: MOCK_TICH_HOP[0]!.id,
    summarization_id: null,
    trigger: 'TEST',
    attempt: 1,
    status: 'SUCCESS',
    http_status: 200,
    response_body: '{"ok":true}',
    error_message: null,
    created_at: '2026-07-06T10:15:00Z',
  },
  {
    id: '55555555-0002-0000-0000-000000000000',
    integration_config_id: MOCK_TICH_HOP[0]!.id,
    summarization_id: '66666666-0001-0000-0000-000000000000',
    trigger: 'AFTER_SUMMARIZE',
    attempt: 2,
    status: 'FAILED',
    http_status: 502,
    response_body: null,
    error_message: 'Bad Gateway',
    created_at: '2026-07-06T09:40:00Z',
  },
];

/** Câu backend trả về, cho bản giả của repository (dữ liệu nghiệp vụ, không dịch). */
export const MOCK_CAU_VAN_BAN = {
  tuyChinh: 'Tùy chỉnh',
  dangDung: 'Đang dùng',
  ngungDung: 'Ngừng dùng',
  capTrenKhongCo: 'Đơn vị trực thuộc không tồn tại',
  khongThayDonVi: 'Không tìm thấy đơn vị',
  khongThayMau: 'Mẫu văn bản không tồn tại',
  daTaoXemTruoc: 'AI đã tạo bản xem trước mẫu văn bản thành công.',
  xemTruocAi: '(Bản xem trước minh hoạ do AI tạo ở bản dữ liệu mẫu.)',
  khongThayTichHop: 'Cấu hình tích hợp không tồn tại',
  chuaCoWebhook: 'Cấu hình này chưa có webhook_url',
};
